<template>
  <div class="search-container">
    <BbInput v-model="filterValue" class="search-input" size="small" :placeholder="t('common.search')" autofocus>
      <template #prepend-inner>
        <BbIcon size="small" name="search" />
      </template>
    </BbInput>
    <FilterFormWithDropdowns :type="filterType" />
  </div>
</template>
<script>
import { ref, watch } from 'vue';
import debounce from 'lodash/debounce';

import { useI18n } from 'vue-i18n';

import { FILTER_TYPE } from '~/constants/documents';

import FilterFormWithDropdowns from '~/services/filter-form-service/components/FilterFormWithDropdowns';
import useFormFilters from '~/composables/useFormFilters';

export default {
  components: { FilterFormWithDropdowns },
  setup() {
    const { t } = useI18n();
    const { setSearchQuery } = useFormFilters();

    const filterValue = ref('');

    // Your debounced logic
    const handleInputSearch = debounce((val) => {
      // set searchQuery on store
      setSearchQuery(val);
      console.log('Debounced value:', val);
    }, 500);

    watch(filterValue, (newVal) => {
      handleInputSearch(newVal);
    });

    return { filterValue, t, filterType: FILTER_TYPE.media };
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-2;

  :deep(.filter-container) {
    background-color: $bb-neutral-0;
    padding: 0;
  }

  :deep(.collapsed-filters) {
    background-color: $bb-neutral-0;
    justify-content: flex-start;
  }
}
</style>
